if (!customElements.get("custom-select")) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
    }

    close() {
      this.classList.remove("is-open");
    }

    handleSort(element) {
      const filterSort = this.closest("[data-filter-sort]");
      if (!filterSort) return;
      filterSort.changeSortBy(element.dataset.value);
    }

    handleChange(element) {
      this.current.innerHTML = element.innerHTML;
      if (this.hasAttribute("data-sort")) this.handleSort(element);
      if (element.dataset.type == "url")
        this.closest("ajax-variant")?.update(element.dataset.value);
      this.querySelector(".is-active")?.classList.remove("is-active");
      element.classList.add("is-active");
      this.close();
    }

    handleOptionChange(element) {
      console.log('handleOptionChange');
      this.updateOOSSelect(element);
      this.handleChange(element);
      this.closest("product-form")?.update(element);
    }

    handleQuantityChange(element) {
      this.handleChange(element);
      this.closest("product-form")?.updateQuantity(element.dataset.value);
    }

    updateCard(element) {
      this.card = this.closest(".js-product-card");
      if (!this.card) return;

      this.updatePrice(element);
      this.card.querySelector("cart-add")?.update(element);

      this.updateImage(element);
    }

    updateOOSSelect(element) {
      console.log('updateOOSSelect');
      let index = element.dataset;
      let thisID = index.id;
      let klaviyoNotify = document.querySelector('.product__actions .notify');
      let klaviyoBtn = document.querySelector('.product__actions .klaviyo-bis-trigger');
      let addToCartBtn = document.querySelector('.product__submit');
      let delayMessage = document.querySelector('div.delay');
      let rechargeWidget = document.querySelector('.rc-widget-injection-parent');
      if (thisID){
        let variantIventoryQty = document.querySelector('ul.inventory-available span[data-index="' + thisID + '"]');
        if (variantIventoryQty && variantIventoryQty.dataset.inventoryQty) {
          // Inventory is 0 or less
          if (variantIventoryQty.dataset.inventoryQty <= 0){
            console.log('variant inventory qty is 0 or less');

            // Check if this is allowed to be sold when sold out
            if ( variantIventoryQty.dataset.value.toLowerCase() !== 'continue') {
              // Less than 0 in stock and marked to stop selling when out of stock
              console.log('variant sold out and do no keep selling');
              klaviyoNotify.classList.remove('d-none');
              klaviyoBtn.style.display = 'flex';
              addToCartBtn.classList.add('d-none');
              delayMessage.classList.remove('d-none');
              rechargeWidget.classList.add('d-none');
            }
            else {
              // Continue selling
              console.log('variant sold out but keep selling');
              klaviyoNotify.classList.add('d-none');
              klaviyoBtn.style.display = 'none';
              if (document.getElementById('flavor_selector_type')){
                if (document.getElementById('flavor_selector_type').value !== 'Lemon Sips'){
                  addToCartBtn.innerText = 'Add to Cart';
                  addToCartBtn.classList.remove('d-none');
                  addToCartBtn.removeAttribute('disabled');
                }
              }
              delayMessage.classList.add('d-none');
              rechargeWidget.classList.remove('d-none');
            }

          }
          // Variant is in stock
          else {
            console.log('variant in stock keep selling');

          }

        }
      }
    }

    updatePrice(element) {
      this.price = this.card.querySelector(".js-price");
      this.price.innerHTML = element.dataset.price;
    }

    updateImage(element) {
      let index = element.dataset;
      if (index.value){
        let variantImgData = document.querySelector('ul.variant-images span[data-value="' + index.value + '"]');
        if (variantImgData && variantImgData.dataset.variantImg) {
          document.querySelector('.product__media .swiper-slide-active img').srcset = variantImgData.dataset.variantImg;
        }
      }

    }

    connectedCallback() {
      this.current = this.querySelector(".js-current");

      if (!this.current) return;

      document.body.addEventListener("click", () => {
        this.close();
      });

      this.addEventListener("drag", (event) => {
        event.stopPropagation();
      });

      this.addEventListener("click", (event) => {
        event.stopPropagation();

        document.querySelectorAll("custom-select").forEach((element) => {
          if (element.classList.contains("is-open")) element.close();
        });

        if (event.target.dataset.price) this.updateCard(event.target);
        // Update Image on Variant Change
        this.updateImage(event.target);
        // Update Inventory on Variant Change
        // this.updateOOSSelect(event.target);
        if (this.dataset.type == "quantity" && event.target.dataset.value)
          return this.handleQuantityChange(event.target);
        if (event.target.dataset.index)
          return this.handleOptionChange(event.target);
        if (event.target.dataset.variantId || event.target.dataset.value)
          return this.handleChange(event.target);
        this.classList.toggle("is-open");
      });
    }
  }
  customElements.define("custom-select", CustomSelect);
}
